export default __webpack_public_path__ + "static/media/news61.7fc56a90.jpg";